import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { isEmpty, eq, toUpper } from 'lodash';

import { getAlphabetAnd123 } from '../../../utils/';
import { buildPathPrefix } from '../../../utils/directoryUtils';

import LocalizedNavLink from '../../router/LocalizedNavLink';

class ABCBookComponent extends React.Component {
    buildPathPrefix = () =>
        buildPathPrefix(
            this.props.locale,
            this.props.isCodePromo,
            this.props.isOffline,
            this.props.isEbon
        );

    render() {
        const { letter } = this.props;

        return (
            !isEmpty(letter) && (
                <section>
                    <hr className="annuaire-menu-alphabet-hr" />
                    <div id="annuaire-menu-alphabet" className="flex-container-h">
                        {getAlphabetAnd123().map(l => {
                            return eq(l, letter) ? (
                                <b key={l}>{toUpper(l)}</b>
                            ) : (
                                <LocalizedNavLink
                                    key={l}
                                    to={`${this.buildPathPrefix()}/alphabetique/${l}`}>
                                    {toUpper(l)}
                                </LocalizedNavLink>
                            );
                        })}
                    </div>
                    <hr className="annuaire-menu-alphabet-hr" />
                </section>
            )
        );
    }
}

ABCBookComponent.propTypes = {
    isCodePromo: PropTypes.bool.isRequired,
    letter: PropTypes.string,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

const mapStateToProps = state => {
    return {
        locale: state.i18n.locale
    };
};
export default connect(mapStateToProps)(ABCBookComponent);



// WEBPACK FOOTER //
// ./src/components/pages/directory/ABCBookComponent.js